// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton_backButton__9w2e7","hidden":"BackButton_hidden__0U6b8"};